export default "__VITE_ASSET__86e40f2b__"